module.exports = function(
  $scope,
  $timeout,
  CustomerModel,
  CustomerDA,
  gettextCatalog,
  IndustrySpecific,
  Notification,
  OfficeModel,
  $state,
  Upload,
) {
  $scope.fileTypes = ['CSV'];
  $scope.fileFormats = ['ISO-8859-1', 'UTF8', 'UCS2', 'ASCII', 'Binary', 'Base64'];
  $scope.delimitters = [
    {
      label: gettextCatalog.getString('Semicolon'),
      value: ';',
    },
    {
      label: gettextCatalog.getString('Comma'),
      value: ',',
    },
  ];

  $scope.fields = [
    {
      label: gettextCatalog.getString('Salutation'),
      name: 'salutation',
    },
    {
      label: gettextCatalog.getString('Firstname'),
      name: 'firstname',
      required: true,
    },
    {
      label: gettextCatalog.getString('Lastname'),
      name: 'lastname',
      required: true,
    },
    {
      label: gettextCatalog.getString('Birthday'),
      name: 'birthday',
    },
    {
      label: gettextCatalog.getString('Telephone'),
      name: 'telephone',
    },
    {
      label: gettextCatalog.getString('Email'),
      name: 'email',
    },
    {
      label: gettextCatalog.getString('Street'),
      name: 'street',
    },
    {
      label: gettextCatalog.getString('Nr'),
      name: 'no',
    },
    {
      label: gettextCatalog.getString('Postal'),
      name: 'postal',
    },
    {
      label: gettextCatalog.getString('City'),
      name: 'city',
    },
    {
      label: gettextCatalog.getString('Note'),
      name: 'note',
    },
  ];

  $scope.settings = {
    fileType: 'CSV',
    fileFormat: 'ISO-8859-1',
    delimiter: ';',
  };

  $scope.$files = [];

  $scope.isFinalStep = false;
  $scope.uploadInProgress = false;

  $scope.goToFileChoose = function() {
    $scope.isFinalStep = false;

    $scope.isPrviewStep = false;
    $scope.isShowAllPreviewItems = false;
  };

  $scope.activateFinalStep = function() {
    $scope.isFinalStep = !!$scope.csvFields;
  };

  $scope.goToReview = function() {
    $scope.isPrviewStep = true;
  };

  $scope.backToImportSettings = function() {
    $scope.isPrviewStep = false;
    $scope.isShowAllPreviewItems = false;
  };

  var A_LETTER_CODE = 65;
  var LATIN_LETTERS = 26;
  $scope.getLetter = function(index) {
    var result = [];

    for (var i = index; i >= 0; i -= LATIN_LETTERS + (i % LATIN_LETTERS)) {
      result.unshift(String.fromCharCode((i % LATIN_LETTERS) + A_LETTER_CODE));
    }

    return result.join('');
  };

  $scope.showPreviewItems = 20;
  $scope.isShowAllPreviewItems = false;
  $scope.toggleShowAll = function() {
    $scope.isShowAllPreviewItems = !$scope.isShowAllPreviewItems;
  };

  $scope.isShowAll = function(item, index) {
    return index > 0 && ($scope.isShowAllPreviewItems || index < $scope.showPreviewItems);
  };

  IndustrySpecific.getLabels().then(function(labels) {
    $scope.customerLabel = gettextCatalog.getString(labels.customer.toLowerCase());
    $scope.customersLabel = gettextCatalog.getString(labels.customers.toLowerCase());
  });

  /**
   * get office data for custom customer fields
   */
  OfficeModel.get(function(error, office) {
    if (!error) {
      if ('customFields' in office.settings) {
        if (angular.isArray(office.settings.customFields.customer)) {
          office.settings.customFields.customer.forEach(function(customField) {
            $scope.fields.push({
              label: customField.label,
              name: customField.name,
              type: 'custom',
            });
          });
        }
      }
    }
  });

  /**
   * generate logo preview
   * @param $files
   */
  $scope.onFileSelect = function($files) {
    if (!$files.length) return;

    $scope.$files = $files;

    $scope.upload();
  };

  $scope.getFileName = function() {
    return _.get($scope.$files, '[0].name', '');
  };

  /**
   * upload file and return the two first lines
   */
  $scope.upload = function() {
    if ($scope.uploadInProgress) return;

    $scope.uploadInProgress = true;

    // upload all files
    Upload.upload({
      url: '/api/office/' + $scope.office._id + '/customers/upload',
      data: $scope.settings,
      file: $scope.$files,
    })
      .progress(function(evt) {
        console.log('upload:' + parseInt((100.0 * evt.loaded) / evt.total));
      })
      .success(function(data) {
        $scope.uploadInProgress = false;

        if (data && data.length < 2)
          return Notification.addErrorMessage(gettextCatalog.getString("File shouldn't be empty"));

        $scope.csvFields = [];

        for (var i = 0; data[0] && i < data[0].length; i++) {
          $scope.csvFields.push($scope.fields[i] || null);
        }

        $scope.sampleData = data;
        $scope.isFinalStep = true;
      })
      .error(function(error) {
        if (error.message == 'file_to_large') {
          Notification.addErrorMessage(gettextCatalog.getString('File is too big (max. 1MB)'));
        } else if (error.message == 'extension_not_allowed') {
          Notification.addErrorMessage(gettextCatalog.getString('File type is not allowed'));
        } else {
          Notification.addErrorMessage(
            gettextCatalog.getString('An unknown error occured (Error: {{error}})', {
              error: error,
            }),
          );
        }

        $scope.uploadInProgress = false;
      });
  };

  $scope.checkOnDuplicates = function(csvField, index) {
    $scope.csvFields[index] = null;
    var existingIndex = $scope.csvFields.indexOf(csvField);

    if (existingIndex > -1) {
      $scope.csvFields[existingIndex] = null;
    }

    $scope.csvFields[index] = csvField;
  };

  /**
   * upload the file again and start import
   */
  $scope.import = function() {
    if ($scope.uploadInProgress) return;

    $scope.uploadInProgress = true;

    Upload.upload({
      url: '/api/office/' + $scope.office._id + '/customers/import',
      data: {
        settings: $scope.settings,
        fields: $scope.csvFields,
        parsedData: $scope.sampleData,
      },
    })
      .progress(function(evt) {
        console.log('upload:' + parseInt((100.0 * evt.loaded) / evt.total));
      })
      .success(function(data, status, headers, config) {
        $scope.uploadInProgress = false;
        var delta = $scope.sampleData.length - data.length - 1; // sampleData has a headers row

        if (delta > 0) {
          Notification.addErrorMessage(
            gettextCatalog.getString('{{count}} data rows duplicated', { count: delta }),
          );
        }

        if (data.length) {
          Notification.addSuccessMessage(
            gettextCatalog.getString('{{count}} data rows imported', { count: data.length }),
          );

          CustomerModel.updateCustomers(data);

          $state.go('private.main.customer');
        } else {
          setTimeout(function() {
            $scope.goToFileChoose();
          }, 300);
        }
      })
      .error(function(error) {
        $scope.uploadInProgress = false;

        if (error.message == 'file_to_large') {
          Notification.addErrorMessage(gettextCatalog.getString('File is too big (max. 1MB)'));
        } else if (error.message == 'extension_not_allowed') {
          Notification.addErrorMessage(gettextCatalog.getString('File type is not allowed'));
        } else {
          Notification.addErrorMessage(
            gettextCatalog.getString('An unknown error occured (Error: {{error}})', {
              error: error,
            }),
          );
        }
      });
  };

  $scope.isValid = function() {
    var lastnamePicked = false;
    var firstnamePicked = false;

    // check for first and lastname
    $scope.csvFields.forEach(function(csvField) {
      if (csvField) {
        if (csvField.name === 'lastname') {
          lastnamePicked = true;
        }
        if (csvField.name === 'firstname') {
          firstnamePicked = true;
        }
      }
    });

    return lastnamePicked && firstnamePicked;
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/customer/upload/CustomerUploadCtrl.js